import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import Geocode from "react-geocode";
import { useLocation } from "react-router-dom";
// import prodImg from "../../assets/images/prod__img.jpg";
// import UnionIcon from "../../assets/images/icons/Union_5.svg";
import PhoneInputComponent from "./PhoneInputComponent";

import Edit_icon from "../../assets/images/icons/edit_icon.svg";
import CompanyLocationService from "../../services/company-location.service";
import AdminToolsDataService from "../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";
import { Button, Checkbox, Col, Input, Modal, Row, Select, Spin, Switch, Table, Tooltip } from "antd";


const CompanyLocation = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const [dealerID, setDealerID] = useState("");
  const [locationDetails, setLocationDetails] = useState();
  const [UserLocationID, setUserLocationID] = useState("");
  // const [selectedLocation, setSelectedLocation] = useState({});
  // const [selectedLocation, setSelectedLocation] = useState({
  //   Address: "",
  //   City: "",
  //   Country: "",
  //   EmailID: "",
  //   Phone: "",
  //   State: "",
  //   Website: "",
  //   Zip: "",
  // });
  const [selectedLocation, setSelectedLocation] = useState({
    Address: "",
    City: "",
    Country: "",
    EmailID: "",
    Phone: "",
    State: "",
    Website: "",
    Zip: "",
    CityId: "",
    StateId: "",
    CountryId: "",
  });
  const [selectedLocationTimingDD, setSelectedLocationTimingDD] = useState({});
  const [completeAddress, setCompleteAddress] = useState("");
  const [countryDD, setCountryDD] = useState([]);
  const [updatedLocationName, setUpdatedLocationName] = useState({});
  const [isHide, setIsHide] = useState({});
  const [initialFlag, setInitialFlag] = useState(true);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [newNameLocation, setNewNameLocation] = useState("");
  const loginDetials = useSelector((state) => state.loginReducer);
  const [delModalVisible, setDelModalVisible] = useState(false);
  const [QRModalVisible, setQRModalVisible] = useState(false);
  const [LocationDetailsLoader, setLocationDetailsLoader] = useState(true);
  const [qrCodeText, setQRCodeText] = useState("");
  const [qrCodeImg, setQRCodeImg] = useState("");
  const [countryListLoading, setCountryListLoading] = useState(false);
  const [validations, setValidations] = useState({
    LocationAddressVal: "",
    LocationCityVal: "",
    LocationStateVal: "",
    LocationZipVal: "",
    LocationCountryVal: "",
    LocationEmailVal: "",
    LocationPhoneVal: "",
    LocationWebsiteVal: "",
  });
  const [stateDD, setStateDD] = useState([]);
  const [cityDD, setCityDD] = useState([]);

  const [stateLoading, setStateLoading] = useState(false);
  const [cityLoading, setCityLoading] = useState(false);

  //const loginDetials = useSelector((state) => state.loginReducer);
  Geocode.setApiKey("AIzaSyAc6HbqpQfHx_SEUcGRHYiQ-tDOoNqtb0g");
  const morningDD = [
    "8 AM",
    "8:30 AM",
    "9 AM",
    "9:30 AM",
    "10 AM",
    "10:30 AM",
    "11 AM",
    "11:30 AM",
    "12 PM",
    "Closed",
  ];
  const morningMONTOFRIDD = [
    "8 AM",
    "8:30 AM",
    "9 AM",
    "9:30 AM",
    "10 AM",
    "10:30 AM",
    "11 AM",
    "11:30 AM",
    "Closed",
  ];
  const noonDD = [
    "12 PM",
    "12:30 PM",
    "1 PM",
    "1:30 PM",
    "2 PM",
    "2:30 PM",
    "3 PM",
    "3:30 PM",
    "4 PM",
    "4:30 PM",
    "5 PM",
    "5:30 PM",
    "6 PM",
    "6:30 PM",
    "7 PM",
    "7:30 PM",
    "8 PM",
    "8:30 PM",
    "9 PM",
    "9:30 PM",
    "10 PM",
    "10:30 PM",
  ];
  const location = useLocation();
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerID(loginDetials.loginDetials.responseData.dealerId);
          if (location.state) {
            if (location.state.id) {
              handleGetLocationDetails(location.state.id);
            }
          } else {
            handleGetLocationDetails(
              loginDetials.loginDetials.responseData.dealerId
            );
          }
          handleGetLocationDropdownDetailsByCountry();
        }
      }
    }
  }, []);

  useEffect(() => {
    if (selectedLocation.CountryId) {
      handleGetLocationDropdownDetailsByState(selectedLocation.CountryId);
    }
  }, [selectedLocation.CountryId]);

  useEffect(() => {
    if (selectedLocation.StateId) {
      handleGetLocationDropdownDetailsByCity(selectedLocation.StateId);
    }
  }, [selectedLocation.StateId]);

  const handleGetLocationDetails = (id) => {
    try {
      let inputData = {
        dealerID: id, //2948
      };
      setLocationDetailsLoader(true);
      //dealerID = id
      CompanyLocationService.GetLocationDetails(inputData).then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData;
        if (message === "Success") {
          setLocationDetailsLoader(false);
          setLocationDetails(responseData);
          getLocationDataHandler(responseData.Table[0].LocationId, id);
          setInitialFlag(false);
          if (Object.keys(responseData.Table[0]).length !== 0)
            setCompleteAddress(
              `${typeof responseData.Table[0].Address !== "object"
                ? responseData.Table[0].Address
                : ""
              } ${typeof responseData.Table[0].City !== "object"
                ? responseData.Table[0].City
                : ""
              } ${typeof responseData.Table[0].Zip !== "object"
                ? responseData.Table[0].Zip
                : ""
              } ${typeof responseData.Table[0].Country !== "object"
                ? responseData.Table[0].Country
                : ""
              }`
            );

          Geocode.fromAddress(
            `${typeof responseData.Table[0].Address !== "object"
              ? responseData.Table[0].Address.length < 15
                ? responseData.Table[0].Address +
                " " +
                responseData.Table[0].City +
                " " +
                responseData.Table[0].State +
                " " +
                responseData.Table[0].Zip +
                " " +
                responseData.Table[0].Country
                : responseData.Table[0].Address
              : ""
            }`
          ).then(
            (response) => {
              const { lat, lng } = response.results[0].geometry.location;
              setLatitude(lat);
              setLongitude(lng);
            },
            (error) => {
              console.error(error);
            }
          );
          // setCountryDD(responseData.Country);
          responseData.Table.map((item, index) => {
            setIsHide((prevState) => ({
              ...prevState,
              [item.LocationId]: true,
            }));
          });
          setLocationDetailsLoader(false);
        }
      });
    } catch (e) {
      console.log(e);
    }
  };
  const handleGetLocationDropdownDetailsByCountry = () => {
    try {
      let inputData = {
        id: 0,
        dropdownType: "Country",
      };
      setCountryListLoading(true);
      AdminToolsDataService.GetLocationDropdownDetails(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setCountryDD(responseData);
              setCountryListLoading(false);
            } else {
              setCountryDD([]);
              setCountryListLoading(false);
            }
          } else {
            setCountryDD([]);
            setCountryListLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setCountryListLoading(false);
        });
    } catch (error) {
      console.log(error);
      setCountryListLoading(false);
    }
  };
  const handleGetLocationDropdownDetailsByState = (countryId) => {
    try {
      let inputData = {
        id: countryId,
        dropdownType: "State",
      };
      setStateLoading(true);
      AdminToolsDataService.GetLocationDropdownDetails(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setStateDD(responseData);
              setStateLoading(false);
            } else {
              setStateDD([]);
              setStateLoading(false);
            }
          } else {
            setStateDD([]);
            setStateLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setStateLoading(false);
        });
    } catch (error) {
      console.log(error);
      setStateLoading(false);
    }
  };
  const handleGetLocationDropdownDetailsByCity = (stateId) => {
    try {
      let inputData = {
        id: stateId,
        dropdownType: "City",
      };
      setCityLoading(true);
      AdminToolsDataService.GetLocationDropdownDetails(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setCityDD(responseData);
              setCityLoading(false);
            } else {
              setCityDD([]);
              setCityLoading(false);
            }
          } else {
            setCityDD([]);
            setCityLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setCityLoading(false);
        });
    } catch (error) {
      console.log(error);
      setCityLoading(false);
    }
  };
  const selectLocationHandler = (id) => {
    if (locationDetails !== undefined) {
      locationDetails.Table.map((item, index) => {
        if (item.LocationId === id) {
          setSelectedLocation(item);
        }
      });
    }
  };
  const formChangeHandler = (e, name, validationName) => {
    let value = "";

    if (name === "Country") {
      value = e;
    } else {
      value = e.target.value;
    }

    if (name === "Address") {
      setValidations((prevState) => ({
        ...prevState,
        LocationAddressVal: "",
      }));
      setCompleteAddress(value);
    } else {
      if (name == "City") {
        setValidations((prevState) => ({
          ...prevState,
          LocationCityVal: "",
        }));
      }
      if (name == "State") {
        setValidations((prevState) => ({
          ...prevState,
          LocationStateVal: "",
        }));
      }
      if (name == "Zip") {
        setValidations((prevState) => ({
          ...prevState,
          LocationZipVal: "",
        }));
      }
      if (name == "Country") {
        setValidations((prevState) => ({
          ...prevState,
          LocationCountryVal: "",
        }));
      }
      if (name == "EmailID") {
        setValidations((prevState) => ({
          ...prevState,
          LocationEmailVal: "",
        }));
      }
      if (name == "Phone") {
        setValidations((prevState) => ({
          ...prevState,
          LocationPhoneVal: "",
        }));
      }
      if (name == "Website") {
        setValidations((prevState) => ({
          ...prevState,
          LocationWebsiteVal: "",
        }));
      }
      setSelectedLocation((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const handleCountryChange = (value) => {
    const selected = countryDD.find((x) => x.id === value);
    setSelectedLocation((prev) => ({
      ...prev,
      CountryId: value,
      Country: selected.name,
      StateId: null,
      State: "",
      CityId: null,
      City: ""
    }));

    setStateDD([]);
    setCityDD([]);

    handleGetLocationDropdownDetailsByState(value);
  };

  const handleStateChange = (value) => {
    const selected = stateDD.find((x) => x.id === value);
    setSelectedLocation((prev) => ({
      ...prev,
      StateId: value,
      State: selected.name,
      CityId: null,
      City: ""
    }));

    setCityDD([]);

    handleGetLocationDropdownDetailsByCity(value);
  };

  const handleCityChange = (value) => {
    const selected = cityDD.find((x) => x.id === value);
    setSelectedLocation((prev) => ({
      ...prev,
      CityId: value,
      City: selected.name
    }));
  };

  const locationNameChangeHandler = (e, id) => {
    const { value } = e.target;
    setUpdatedLocationName((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const getLocationDataHandler = async (locationid, dId) => {
    setValidations({
      LocationAddressVal: "",
      LocationCityVal: "",
      LocationStateVal: "",
      LocationZipVal: "",
      LocationCountryVal: "",
      LocationEmailVal: "",
      LocationPhoneVal: "",
      LocationWebsiteVal: "",
    });

    selectLocationHandler(locationid);

    const inputData = {
      dealerID: dId,
      locationID: locationid,
    };

    setCompleteAddress("");

    let isMounted = true;

    try {
      const response = await CompanyLocationService.GetLocationData(inputData);

      if (!isMounted) return;

      const message = response?.data?.message;
      const responseData = response?.data?.responseData;

      if (message === "Success") {
        const data = responseData?.Table?.[0] || {};
        const address =
          typeof data.address === "string" && data.address.trim() !== ""
            ? data.address
            : "Washington, USA";

        try {
          const geoRes = await Geocode.fromAddress(address);
          if (!isMounted) return;

          const { lat, lng } = geoRes.results[0].geometry.location;
          setLatitude(lat);
          setLongitude(lng);
        } catch (err) {
          console.error(err);
        }

        //SET DATA SAFE
        setSelectedLocation({
          Address: typeof data.address === "string" ? data.address : "",
          City: typeof data.city === "string" ? data.city : "",
          Country: data.countryName || data.country || "",
          EmailID: typeof data.emailID === "string" ? data.emailID : "",
          Phone: typeof data.phone === "string" ? data.phone : "",
          State: typeof data.state === "string" ? data.state : "",
          Website: typeof data.website === "string" ? data.website : "",
          Zip: typeof data.zip === "string" ? data.zip : "",
          CountryId: data.countryId || 0,
          StateId: data.stateId || 0,
          CityId: data.cityId || 0,
        });

        setCompleteAddress(
          typeof data.address === "string" ? data.address : ""
        );

        setUserLocationID(data.locationId || "");
        setQRCodeImg(data.qrCodeImagepath || "");

        if (responseData?.Table1?.length > 0) {
          setSelectedLocationTimingDD(responseData.Table1[0]);
        } else {
          setSelectedLocationTimingDD(null);
        }

      } else {
        setSelectedLocationTimingDD(null);
        setCompleteAddress("");
        setUserLocationID("");
      }
    } catch (e) {
      console.error(e);
    }
  };

  // const getLocationDataHandler = (locationid, dId) => {
  //   setValidations({
  //     LocationAddressVal: "",
  //     LocationCityVal: "",
  //     LocationStateVal: "",
  //     LocationZipVal: "",
  //     LocationCountryVal: "",
  //     LocationEmailVal: "",
  //     LocationPhoneVal: "",
  //     LocationWebsiteVal: "",
  //   });
  //   try {
  //     selectLocationHandler(locationid);
  //     let inputData = {
  //       dealerID: dId, //2948
  //       locationID: locationid,
  //     };
  //     setCompleteAddress("");
  //     CompanyLocationService.GetLocationData(inputData).then((response) => {
  //       let message = response.data.message;
  //       let responseData = response.data.responseData;
  //       if (message === "Success") {
  //         console.log(responseData.Table[0].address, "address")
  //        const address =
  //           typeof responseData?.Table?.[0]?.address === "string" &&
  //           responseData.Table[0].address.trim() !== ""
  //             ? responseData.Table[0].address
  //             : "Washington, USA";

  //         console.log(responseData.Table[0].address, "address after")


  //         Geocode.fromAddress(address).then(
  //           (response) => {
  //             const { lat, lng } = response.results[0].geometry.location;
  //             setLatitude(lat);
  //             setLongitude(lng);
  //           },
  //           (error) => {
  //             console.error(error);
  //           }
  //         );

  //         if (Object.keys(responseData).length !== 0) {
  //           if (responseData.Table.length !== 0) {
  //             const data = responseData?.Table?.[0] || {};

  //             setSelectedLocation({
  //               Address: typeof data.address === "string" ? data.address : "",
  //               City: typeof data.city === "string" ? data.city : "",
  //               Country: data.countryName || data.country || "",
  //               EmailID: typeof data.emailID === "string" ? data.emailID : "",
  //               Phone: typeof data.phone === "string" ? data.phone : "",
  //               State: typeof data.state === "string" ? data.state : "",
  //               Website: typeof data.website === "string" ? data.website : "",
  //               Zip: typeof data.zip === "string" ? data.zip : "",
  //               CountryId: data.countryId || 0,
  //               StateId: data.stateId || 0,
  //               CityId: data.cityId || 0,
  //             });
  //             setCompleteAddress(
  //               typeof responseData.Table[0].address === "string"
  //                 ? responseData.Table[0].address
  //                 : ""
  //             );
  //             setUserLocationID(responseData.Table[0].locationId);
  //             setQRCodeImg(responseData.Table[0].qrCodeImagepath);
  //           }
  //           if (responseData.Table1.length !== 0) {
  //             setSelectedLocationTimingDD(responseData.Table1[0]);
  //           } else {
  //             setSelectedLocationTimingDD(null);
  //           }
  //         }
  //       } else {
  //         setSelectedLocationTimingDD(null);
  //         setCompleteAddress("");
  //         setUserLocationID("");
  //       }
  //     });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };
  const updateLocationNameHandler = (id) => {
    try {
      let inputData = {
        dealerID: dealerID, //2948,
        locationID: id,
        locationName: updatedLocationName[id],
      };
      CompanyLocationService.UpdateLocationName(inputData).then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData;
        if (message === "Success") {
          handleGetLocationDetails(dealerID);
          NotificationManager.success(t("Location Updated Successfully."));
        } else {
          NotificationManager.error(t("Location Update Failed."));
        }
      });
    } catch (e) {
      console.log(e);
    }
  };
  const updateTimeDD = (e, name) => {
    var e1 = "";
    var e2 = "";
    var name1 = "";
    var name2 = "";
    var name3 = "";
    if (name === "sundayStart" || name === "sundayEnd") {
      name1 = "storeClosedSun";
      name2 = "sundayStart";
      name3 = "sundayEnd";
    } else if (name === "mondayStart" || name === "mondayEnd") {
      name1 = "storeClosedMon";
      name2 = "mondayStart";
      name3 = "mondayEnd";
    } else if (name === "tuesdayStart" || name === "tuesdayEnd") {
      name1 = "storeClosedTue";
      name2 = "tuesdayStart";
      name3 = "tuesdayEnd";
    } else if (name === "wednesdayStart" || name === "wednesdayEnd") {
      name1 = "storeClosedWed";
      name2 = "wednesdayStart";
      name3 = "wednesdayEnd";
    } else if (name === "thursdayStart" || name === "thursdayEnd") {
      name1 = "storeClosedThu";
      name2 = "thursdayStart";
      name3 = "thursdayEnd";
    } else if (name === "fridayStart" || name === "fridayEnd") {
      name1 = "storeClosedFri";
      name2 = "fridayStart";
      name3 = "fridayEnd";
    } else if (name === "saturdayStart" || name === "saturdayEnd") {
      name1 = "storeClosedSat";
      name2 = "saturdayStart";
      name3 = "saturdayEnd";
    }
    if (e === "Closed") {
      e1 = "Yes";
      e2 = "";
      e = "";
      setSelectedLocationTimingDD((prevState) => ({
        ...prevState,
        [name1]: e1,
        [name2]: e,
        [name3]: e2,
      }));
    } else {
      e1 = "";
      setSelectedLocationTimingDD((prevState) => ({
        ...prevState,
        [name1]: e1,
        [name]: e,
      }));
    }
  };
  const updateLocationHandler = () => {
    const isValid = handleValidation();
    if (!isValid) {
      return false;
    }

    if (validations.LocationPhoneVal) {
      return;
    }
    try {
      if (
        selectedLocation.Country !== ""
      ) {
        let inputData = {
          txtAddress: completeAddress,
          txtCity: cityDD.length > 0 ? selectedLocation.City : "",
          txtState: stateDD.length > 0 ? selectedLocation.State : "",
          txtZip: selectedLocation.Zip,
          drpcountry: selectedLocation.Country.toString(),
          countryId: selectedLocation.CountryId,
          stateId: stateDD.length > 0 ? selectedLocation.StateId : null,
          cityId: cityDD.length > 0 ? selectedLocation.CityId : null,
          txtPhone: selectedLocation.Phone,
          txtEmail: selectedLocation.EmailID,
          ddlStartSunday:
            selectedLocationTimingDD?.storeClosedSun === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.sundayStart || "",
          ddlEndSunday:
            selectedLocationTimingDD?.storeClosedSun === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.sundayEnd || "",
          ddlMondayStart:
            selectedLocationTimingDD?.storeClosedMon === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.mondayStart || "",
          ddlMondayEnd:
            selectedLocationTimingDD?.storeClosedMon === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.mondayEnd || "",
          ddlTuesdayStart:
            selectedLocationTimingDD?.storeClosedTue === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.tuesdayStart || "",
          ddlTuesdayEnd:
            selectedLocationTimingDD?.storeClosedTue === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.tuesdayEnd || "",
          ddlWednesdayStart:
            selectedLocationTimingDD?.storeClosedWed === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.wednesdayStart || "",
          ddlWednesdayEnd:
            selectedLocationTimingDD?.storeClosedWed === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.wednesdayEnd || "",
          ddlThursdayStart:
            selectedLocationTimingDD?.storeClosedThu === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.thursdayStart || "",
          ddlThursdayEnd:
            selectedLocationTimingDD?.storeClosedThu === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.thursdayEnd || "",
          ddlFridayStart:
            selectedLocationTimingDD?.storeClosedFri === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.fridayStart || "",
          ddlFridayEnd:
            selectedLocationTimingDD?.storeClosedFri === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.fridayEnd || "",
          ddlSaturdayStart:
            selectedLocationTimingDD?.storeClosedSat === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.saturdayStart || "",
          ddlSaturdayEnd:
            selectedLocationTimingDD?.storeClosedSat === "Yes"
              ? "Closed"
              : selectedLocationTimingDD?.saturdayEnd || "",
          txtWebsite: selectedLocation.Website,
          dealerID: dealerID.toString(),
          // locationID: selectedLocation.LocationId.toString(),
          locationID: UserLocationID ? UserLocationID.toString() : "",
        };
        CompanyLocationService.UpdateLocation(inputData).then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            NotificationManager.success(t("Location Updated Successfully."));
            // handleGetLocationDetails(dealerID);
            getLocationDataHandler(UserLocationID, dealerID);
          } else {
            NotificationManager.error(t("Location Update Failed."));
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
  const MyMapComponent = useMemo(
    () =>
      withScriptjs(
        withGoogleMap((props) => {
          return (
            <GoogleMap
              key={"AIzaSyAc6HbqpQfHx_SEUcGRHYiQ-tDOoNqtb0g"}
              defaultZoom={5}
              defaultCenter={{
                lat: Number(latitude === "" ? 37.717564 : latitude),
                lng: Number(longitude === "" ? -88.18988 : longitude),
              }}
            >
              <React.Fragment>
                <Marker
                  position={{
                    lat: Number(latitude === "" ? 37.717564 : latitude),
                    lng: Number(longitude === "" ? -88.18988 : longitude),
                  }}
                  title={"DealerCompany" + "::" + "FullAddress"}
                ></Marker>
              </React.Fragment>
            </GoogleMap>
          );
        })
      ),
    [latitude, longitude]
  );
  const onNewNameChaneHandler = (e) => {
    let { value } = e.target;
    setNewNameLocation(value);
  };
  const newLocationHandler = () => {
    try {
      let inputData = {
        txtAddLocation: newNameLocation || "",
        DealerID: dealerID.toString(),
      };
      CompanyLocationService.AddNewLocation(inputData).then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData;
        if (message === "Success") {
          handleGetLocationDetails(dealerID);
          NotificationManager.success(t("New Location Added Successfully."));
          setNewNameLocation("");
        } else {
          NotificationManager.error(t("New Location Adding Failed."));
        }
      });
    } catch (e) {
      console.log(e);
    }
  };
  const deleteLocationDataHandler = () => {
    try {
      // selectLocationHandler(locationid);
      let inputData = {
        dealerID: dealerID ? dealerID.toString() : "", //2948
        locationID: UserLocationID ? UserLocationID : "",
      };
      // setCompleteAddress("");
      CompanyLocationService.DeleteLocation(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            NotificationManager.success(t("Location Deleted Successfully."));
            handleGetLocationDetails(dealerID);
          } else {
            NotificationManager.error(t("Location Delete Failed."));
          }
        })
        .catch((error) => {
          NotificationManager.error(t("Location Delete Failed."));
        });
    } catch (e) {
      console.log(e);
    }
    setDelModalVisible(false);
  };
  const updateQRCodeHandler = () => {
    try {
      // selectLocationHandler(locationid);
      let inputData = {
        dealerID: dealerID ? dealerID.toString() : "", //2948
        locationID: UserLocationID ? UserLocationID : "",
        txtQRDetails: qrCodeText ? qrCodeText : "",
      };
      // setCompleteAddress("");
      CompanyLocationService.QRCodeTextUpdate(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            NotificationManager.success(t("QR Code Generated"));
            setQRCodeText("");
            handleGetLocationDetails(dealerID);
          } else {
            NotificationManager.error(t("QR Code Generate Failed."));
          }
        })
        .catch((error) => {
          NotificationManager.error(t("QR Code Generate Failed."));
        });
    } catch (e) {
      console.log(e);
    }
    setQRModalVisible(false);
  };
  const handleDeleteUser = (e) => {
    setDelModalVisible(true);
  };

  const handleDeleteCancel = () => {
    setDelModalVisible(false);
  };
  const handleQRCOdeGenerator = () => {
    setQRModalVisible(true);
    setQRCodeText("");
  };
  const handleCloseQRCOdeGenerator = () => {
    setQRModalVisible(false);
  };

  const handleValidation = () => {
    const validations = {};
    var validEmailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let isValid = true;
    if (!completeAddress) {
      isValid = false;
      validations.LocationAddressVal = t("Address is compulsory");
    } else {
      validations.LocationAddressVal = "";
    }
    if (stateDD.length > 0) {
      if (!selectedLocation.StateId) {
        isValid = false;
        validations.LocationStateVal = t("State is compulsory");
      }
    } else {
      validations.LocationStateVal = "";
    }

    if (cityDD.length > 0) {
      if (!selectedLocation.CityId) {
        isValid = false;
        validations.LocationCityVal = t("City is compulsory");
      }
    } else {
      validations.LocationCityVal = "";
    }
    if (!selectedLocation.Zip) {
      isValid = false;
      validations.LocationZipVal = t("Zip is compulsory");
    } else {
      validations.LocationZipVal = "";
    }
    if (!selectedLocation.Country) {
      isValid = false;
      validations.LocationCountryVal = t("Country is compulsory");
    } else {
      validations.LocationCountryVal = "";
    }
    var validRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (!selectedLocation.EmailID) {
      isValid = false;
      validations.LocationEmailVal = t("Email is compulsory");
    } else if (!selectedLocation.EmailID.match(validRegex)) {
      isValid = false;
      validations.LocationEmailVal = t("Email address is Invalid");
    } else {
      validations.LocationEmailVal = "";
    }
    if (!selectedLocation.Phone) {
      isValid = false;
      validations.LocationPhoneVal = t("Phone is compulsory");
    } else if (
      (selectedLocation.Phone.length < 15 &&
        selectedLocation.Phone.includes("-") &&
        /^[0-9]+$/.test(selectedLocation.Phone)) ||
      (selectedLocation.Phone.length < 15 &&
        selectedLocation.Phone.includes("+") &&
        /^[0-9]+$/.test(selectedLocation.Phone))
    ) {
      validations.LocationPhoneVal = "";
    } else if (
      /^0*$/.test(selectedLocation.Phone) ||
      /[a-zA-Z@{}#$%?/^*&]/g.test(selectedLocation.Phone)
    ) {
      isValid = false;
      validations.LocationPhoneVal = t("Phone number is invalid");
    } else if (
      selectedLocation.Phone.length > 15 ||
      selectedLocation.Phone.length < 10
    ) {
      isValid = false;
      validations.LocationPhoneVal = t("Phone number is invalid");
    } else {
      validations.LocationPhoneVal = "";
    }
    // if (!selectedLocation.Website) {
    //   isValid = false;
    //   validations.LocationWebsiteVal = t("Website is compulsory");
    // } else {
    //   validations.LocationWebsiteVal = "";
    // }
    if (!isValid) {
      setValidations(validations);
    }

    return isValid;
  };

  const getSafeValue = (val) => {
    if (!val) return "";
    if (typeof val === "object") {
      if (val.name) return val.name;
      return "";
    }
    return val;
  };

  const getSafeTime = (val) => {
    if (!val) return undefined;
    if (typeof val === "object") return undefined;
    return val;
  };

  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields magento__mapping permission__section">
        <div className="row">
          <div className="col-md-12">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0"> {t("Locations")} </h4>
            </div>
          </div>

          <div className="col-md-12 mb-5">
            <div className="map__section">
              {/* <p> {t("Add Map Here")} </p> */}
              <MyMapComponent
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAc6HbqpQfHx_SEUcGRHYiQ-tDOoNqtb0g&v=3.exp"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `300px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            </div>
          </div>

          <div className="col-md-3">
            <div className="input__block mb-0">
              <label> {t("Locations")} </label>
              <div className="row">
                <div className="col-9">
                  <input
                    type="text"
                    onChange={(e) => onNewNameChaneHandler(e)}
                    value={newNameLocation}
                  />
                </div>
                <div className="col-3">
                  <button className="primary-btn">
                    <i
                      className="fa fa-plus m-0"
                      onClick={newLocationHandler}
                    ></i>
                  </button>
                </div>
              </div>
              <div className="col-md-12">
                <hr />
              </div>
            </div>

            <div className="location-box">
              <Spin spinning={LocationDetailsLoader}>
                {locationDetails &&
                  Object.keys(locationDetails).length > 0 &&
                  locationDetails.Table.map((item, index) => {
                    return (
                      <>
                        <div className="location__blocks" key={item.LocationId}>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="location__details">
                                <label
                                  // className={`active pe-auto ${selectedLocation.LocationId ===
                                  //     item.LocationId
                                  //     ? "linkText"
                                  //     : ""
                                  //   }`}
                                  className={`active pe-auto ${(selectedLocation.LocationId ||
                                    UserLocationID) == item.LocationId
                                    ? "linkText"
                                    : "pointer"
                                    }`}
                                  onClick={() =>
                                    getLocationDataHandler(
                                      item.LocationId,
                                      dealerID
                                    )
                                  }
                                >
                                  {item.LocationName &&
                                    typeof item.LocationName === "object"
                                    ? Object.keys(item.LocationName).length ===
                                      0
                                      ? ""
                                      : item.LocationName
                                    : item.LocationName || ""}
                                </label>
                                <div className="action__btns">
                                  <div className="image__block">
                                    <img
                                      src={Edit_icon}
                                      alt=""
                                      onClick={() =>
                                        setIsHide((prevState) => ({
                                          ...prevState,
                                          [item.LocationId]:
                                            !isHide[item.LocationId],
                                        }))
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`row my-3 ${isHide[item.LocationId] ? "d-none" : ""
                              }`}
                          >
                            <div className="col-9">
                              <div className="input__block mb-0">
                                <input
                                  type="text"
                                  value={
                                    Object.keys(updatedLocationName).length !==
                                      0 &&
                                      updatedLocationName[item.LocationId] !==
                                      undefined
                                      ? updatedLocationName[item.LocationId]
                                      : item.LocationName &&
                                        typeof item.LocationName === "object"
                                        ? Object.keys(item.LocationName)
                                          .length === 0
                                          ? ""
                                          : item.LocationName
                                        : item.LocationName || ""
                                  }
                                  //value={item.LocationName}
                                  onChange={(e) =>
                                    locationNameChangeHandler(
                                      e,
                                      item.LocationId
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-3 topspace text-right">
                              <span
                                className="linkText d-block"
                                onClick={() => {
                                  setIsHide((prevState) => ({
                                    ...prevState,
                                    [item.LocationId]: !isHide[item.LocationId],
                                  }));

                                  setUpdatedLocationName((prevState) => ({
                                    ...prevState,
                                    [item.LocationId]: item.LocationName,
                                  }));
                                }}
                              >
                                {" "}
                                {t("Cancel")}{" "}
                              </span>
                              <span
                                className="linkText d-block"
                                onClick={() =>
                                  updateLocationNameHandler(item.LocationId)
                                }
                              >
                                {" "}
                                {t("Update")}{" "}
                              </span>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
              </Spin>
            </div>
            {/* <div className="location__blocks">
              <div className="row">
                  <div className="col-md-12">
                      <div className="location__details">
                        <label className="active"> {t("Location 1")} </label>
                        <div className="action__btns">
                            <div className="image__block">
                              <img
                                src={Edit_icon}
                                alt=""
                              />
                            </div>
                        </div>
                      </div>
                  </div>
              </div>
              <div className="row d-none">
                  <div className="col-9">
                    <div className="input__block mb-0">
                      <input type="text" />
                    </div>
                  </div>
                  <div className="col-3 topspace">
                      <span className="linkText d-block"> {t("Cancel")} </span>
                      <span className="linkText d-block"> {t("Update")} </span>
                  </div>
                </div>
            </div> */}
          </div>

          <div className="col-md-6 form__section">
            <div className="row">
              <div className="col-md-12">
                <div className="input__block">
                  <label>
                    {" "}
                    {t("Address")}
                    <span className="mandatory">*</span>
                  </label>
                  <textarea
                    className={
                      !completeAddress && validations.LocationAddressVal
                        ? "border__red"
                        : ""
                    }
                    value={completeAddress}
                    onChange={(e) =>
                      formChangeHandler(e, "Address", "LocationAddressVal")
                    }
                  ></textarea>
                  {!completeAddress && validations.LocationAddressVal ? (
                    <div className="text-danger">
                      {validations.LocationAddressVal}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="input__block">
                  <label>
                    {" "}
                    {t("City")}
                    <span className="mandatory">*</span>
                  </label>
                  <Select
                    showSearch
                    className={
                      !selectedLocation.City &&
                        validations.LocationCityVal
                        ? "border__red"
                        : "border__grey"
                    }
                    placeholder=""
                    optionFilterProp="children"
                    value={selectedLocation.CityId > 0 ? selectedLocation.CityId : undefined}
                    // value={
                    //   selectedLocation.CityId && selectedLocation.CityId !== 0
                    //     ? selectedLocation.CityId
                    //     : (selectedLocation.City ? 0 : undefined)
                    // }
                    onChange={(e) =>
                      handleCityChange(e)
                    }
                  >
                    {(!selectedLocation.CityId || selectedLocation.CityId === 0) && selectedLocation.City && (
                      <Option key={0} value={0}>
                        {typeof selectedLocation.City === "string"
                          ? selectedLocation.City
                          : ""}
                      </Option>
                      // <Option key={0} value={0}>
                      //   {selectedLocation.City}
                      // </Option>
                    )}
                    {cityDD.length > 0 &&
                      cityDD.map((item, index) => {
                        return (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        );
                      })}
                  </Select>
                  {validations.LocationCityVal ? (
                    <div className="text-danger">
                      {validations.LocationCityVal}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="input__block">
                  <label>
                    {" "}
                    {t("State")}
                    <span className="mandatory">*</span>
                  </label>
                  <Select
                    showSearch
                    className={
                      !selectedLocation.State &&
                        validations.LocationStateVal
                        ? "border__red"
                        : "border__grey"
                    }
                    placeholder=""
                    optionFilterProp="children"
                    value={
                      selectedLocation.StateId && selectedLocation.StateId !== 0
                        ? selectedLocation.StateId
                        : (selectedLocation.State ? 0 : undefined)
                    }
                    onChange={(e) =>
                      handleStateChange(e)
                    }
                  >
                    {(!selectedLocation.StateId || selectedLocation.StateId === 0) && selectedLocation.State && (
                      <Option key={0} value={0}>
                        {getSafeValue(selectedLocation.State)}
                      </Option>
                    )}
                    {stateDD.length > 0 &&
                      stateDD.map((item, index) => {
                        return (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        );
                      })}
                  </Select>
                  {validations.LocationStateVal ? (
                    <div className="text-danger">
                      {validations.LocationStateVal}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="input__block">
                  <label>
                    {" "}
                    {t("Zip")}
                    <span className="mandatory">*</span>
                  </label>
                  <input
                    type="text"
                    className={
                      !selectedLocation.Zip &&
                        validations.LocationZipVal
                        ? "border__red"
                        : ""
                    }
                    value={selectedLocation.Zip || ""}
                    // value={
                    //   typeof selectedLocation.Zip !== "object"
                    //     ? selectedLocation.Zip
                    //     : ""
                    // }
                    onChange={(e) =>
                      formChangeHandler(e, "Zip", "LocationZipVal")
                    }
                  />
                  {validations.LocationZipVal ? (
                    <div className="text-danger">
                      {validations.LocationZipVal}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="input__block">
                  <label>
                    {" "}
                    {t("Country")}
                    <span className="mandatory">*</span>
                  </label>
                  <Select
                    showSearch
                    className={
                      !selectedLocation.Country &&
                        validations.LocationCountryVal
                        ? "border__red"
                        : "border__grey"
                    }
                    placeholder=""
                    optionFilterProp="children"
                    value={
                      selectedLocation.CountryId && selectedLocation.CountryId !== 0
                        ? selectedLocation.CountryId
                        : (selectedLocation.Country ? 0 : undefined)
                    }
                    onChange={(e) =>
                      handleCountryChange(e)
                    }
                  >
                    {(!selectedLocation.CountryId || selectedLocation.CountryId === 0) && selectedLocation.Country && (
                      <Option key={0} value={0}>
                        {getSafeValue(selectedLocation.Country)}
                      </Option>
                    )}
                    {countryDD.length > 0 &&
                      countryDD.map((item, index) => {
                        return (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        );
                      })}
                  </Select>
                  {validations.LocationCountryVal ? (
                    <div className="text-danger">
                      {validations.LocationCountryVal}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="input__block">
                  <label>
                    {" "}
                    {t("Location E-Mail")}
                    <span className="mandatory">*</span>
                  </label>
                  <input
                    type="email"
                    className={
                      !selectedLocation.EmailID &&
                        validations.LocationEmailVal
                        ? "border__red"
                        : ""
                    }
                    value={
                      typeof selectedLocation.EmailID !== "object"
                        ? selectedLocation.EmailID
                        : ""
                    }
                    onChange={(e) =>
                      formChangeHandler(e, "EmailID", "LocationEmailVal")
                    }
                  />
                  {validations.LocationEmailVal ? (
                    <div className="text-danger">
                      {validations.LocationEmailVal}
                    </div>
                  ) : null}
                </div>
              </div>
              {/* <div className="col-md-6">
                <div className="input__block">
                  <label>
                    {" "}
                    {t("Location Phone")}
                    <span className="mandatory">*</span>
                  </label>
                  <input
                    type="text"
                    className={
                      (!selectedLocation.Phone ||
                        Object.keys(selectedLocation.Phone).length == 0) &&
                      validations.LocationPhoneVal
                        ? "border__red"
                        : ""
                    }
                    value={
                      typeof selectedLocation.Phone !== "object"
                        ? selectedLocation.Phone
                        : ""
                    }
                    onChange={(e) =>
                      formChangeHandler(e, "Phone", "LocationPhoneVal")
                    }
                  />
                  {validations.LocationPhoneVal ? (
                    <div className="text-danger">
                      {validations.LocationPhoneVal}
                    </div>
                  ) : null}
                </div>
              </div> */}
              <div className="col-md-6">
                <PhoneInputComponent
                  t={t}
                  phone={typeof selectedLocation.Phone !== "object" ? selectedLocation.Phone : ""}
                  setPhone={(val) =>
                    formChangeHandler({ target: { name: "Phone", value: val } }, "Phone", "LocationPhoneVal")
                  }
                  phoneError={validations.LocationPhoneVal}
                  setPhoneError={(err) =>
                    setValidations((prev) => ({ ...prev, LocationPhoneVal: err }))
                  }
                />
              </div>

              <div className="col-md-6">
                <div className="input__block">
                  <label>
                    {" "}
                    {t("Website")}
                    {/* <span className="mandatory">*</span> */}
                  </label>
                  <input
                    type="text"
                    className={
                      !selectedLocation.Website &&
                        validations.LocationWebsiteVal
                        ? "border__red"
                        : ""
                    }
                    value={
                      typeof selectedLocation.Website !== "object"
                        ? selectedLocation.Website
                        : ""
                    }
                    onChange={(e) =>
                      formChangeHandler(e, "Website", "LocationWebsiteVal")
                    }
                  />
                  {validations.LocationWebsiteVal ? (
                    <div className="text-danger">
                      {validations.LocationWebsiteVal}
                    </div>
                  ) : null}
                </div>
              </div>

              <div class="col-md-12">
                <button
                  type="button"
                  class="primary-btn mr-2"
                  onClick={() => updateLocationHandler()}
                >
                  {" "}
                  {t("Update Location")}{" "}
                </button>
                <button
                  type="button"
                  className="primary-btn"
                  onClick={() => handleDeleteUser()}
                >
                  {" "}
                  {t("Delete")}{" "}
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="right__section">
              <div className="row m-0">
                <div className="col-md-12 p-0">
                  <div className="input__block">
                    <label> {t("Hours of Operation")} </label>
                  </div>
                </div>
                <div className="col-md-12 p-0 hour__operation">
                  <div className="d-flex input__block">
                    <label className="mr-2"> {t("Sun")} </label>
                    <Select
                      className="border__grey mr-2"
                      placeholder="--"
                      optionFilterProp="children"
                      value={
                        selectedLocationTimingDD?.storeClosedSun === "Yes"
                          ? "Closed"
                          : selectedLocationTimingDD?.sundayStart || ""
                      }
                      onChange={(e) => updateTimeDD(e, "sundayStart")}
                    >
                      {morningDD.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                    {selectedLocationTimingDD?.storeClosedSun !== "Yes" && (
                      <Select
                        className="border__grey"
                        placeholder="--"
                        optionFilterProp="children"
                        value={selectedLocationTimingDD?.sundayEnd || ""}
                        onChange={(e) => updateTimeDD(e, "sundayEnd")}
                      >
                        {noonDD.map((item, index) => (
                          <Option key={index} value={item}>
                            {item}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </div>

                  <div className="d-flex input__block">
                    <label className="mr-2"> {t("Mon")} </label>
                    <Select
                      className="border__grey mr-2"
                      placeholder="--"
                      optionFilterProp="children"
                      value={
                        selectedLocationTimingDD?.storeClosedMon === "Yes"
                          ? "Closed"
                          : selectedLocationTimingDD?.mondayStart || ""
                      }
                      onChange={(e) => updateTimeDD(e, "mondayStart")}
                    >
                      {morningMONTOFRIDD.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                    {selectedLocationTimingDD?.storeClosedMon !== "Yes" && (
                      <Select
                        className="border__grey"
                        placeholder="--"
                        optionFilterProp="children"
                        value={selectedLocationTimingDD?.mondayEnd || ""}
                        onChange={(e) => updateTimeDD(e, "mondayEnd")}
                      >
                        {noonDD.map((item, index) => (
                          <Option key={index} value={item}>
                            {item}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </div>

                  <div className="d-flex input__block">
                    <label className="mr-2"> {t("Tues")} </label>
                    <Select
                      className="border__grey mr-2"
                      placeholder="--"
                      optionFilterProp="children"
                      value={
                        selectedLocationTimingDD?.storeClosedTue === "Yes"
                          ? "Closed"
                          : selectedLocationTimingDD?.tuesdayStart || ""
                      }
                      onChange={(e) => updateTimeDD(e, "tuesdayStart")}
                    >
                      {morningMONTOFRIDD.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                    {selectedLocationTimingDD?.storeClosedTue !== "Yes" && (
                      <Select
                        className="border__grey"
                        placeholder="--"
                        optionFilterProp="children"
                        value={selectedLocationTimingDD?.tuesdayEnd || ""}
                        onChange={(e) => updateTimeDD(e, "tuesdayEnd")}
                      >
                        {noonDD.map((item, index) => (
                          <Option key={index} value={item}>
                            {item}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </div>

                  <div className="d-flex input__block">
                    <label className="mr-2"> {t("Wed")} </label>
                    <Select
                      className="border__grey mr-2"
                      placeholder="--"
                      optionFilterProp="children"
                      value={
                        selectedLocationTimingDD?.storeClosedWed === "Yes"
                          ? "Closed"
                          : selectedLocationTimingDD?.wednesdayStart || ""
                      }
                      onChange={(e) => updateTimeDD(e, "wednesdayStart")}
                    >
                      {morningMONTOFRIDD.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                    {selectedLocationTimingDD?.storeClosedWed !== "Yes" && (
                      <Select
                        className="border__grey"
                        placeholder="--"
                        optionFilterProp="children"
                        value={selectedLocationTimingDD?.wednesdayEnd || ""}
                        onChange={(e) => updateTimeDD(e, "wednesdayEnd")}
                      >
                        {noonDD.map((item, index) => (
                          <Option key={index} value={item}>
                            {item}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </div>

                  <div className="d-flex input__block">
                    <label className="mr-2"> {t("Thu")} </label>
                    <Select
                      className="border__grey mr-2"
                      placeholder="--"
                      optionFilterProp="children"
                      value={
                        selectedLocationTimingDD?.storeClosedThu === "Yes"
                          ? "Closed"
                          : selectedLocationTimingDD?.thursdayStart || ""
                      }
                      onChange={(e) => updateTimeDD(e, "thursdayStart")}
                    >
                      {morningMONTOFRIDD.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                    {selectedLocationTimingDD?.storeClosedThu !== "Yes" && (
                      <Select
                        className="border__grey"
                        placeholder="--"
                        optionFilterProp="children"
                        value={selectedLocationTimingDD?.thursdayEnd || ""}
                        onChange={(e) => updateTimeDD(e, "thursdayEnd")}
                      >
                        {noonDD.map((item, index) => (
                          <Option key={index} value={item}>
                            {item}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </div>
                  <div className="d-flex input__block">
                    <label className="mr-2"> {t("Fri")} </label>
                    <Select
                      className="border__grey mr-2"
                      placeholder="--"
                      optionFilterProp="children"
                      value={
                        selectedLocationTimingDD?.storeClosedFri === "Yes"
                          ? "Closed"
                          : selectedLocationTimingDD?.fridayStart || ""
                      }
                      onChange={(e) => updateTimeDD(e, "fridayStart")}
                    >
                      {morningMONTOFRIDD.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                    {selectedLocationTimingDD?.storeClosedFri !== "Yes" && (
                      <Select
                        className="border__grey"
                        placeholder="--"
                        optionFilterProp="children"
                        value={selectedLocationTimingDD?.fridayEnd || ""}
                        onChange={(e) => updateTimeDD(e, "fridayEnd")}
                      >
                        {noonDD.map((item, index) => (
                          <Option key={index} value={item}>
                            {item}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </div>

                  <div className="d-flex input__block">
                    <label className="mr-2"> {t("Sat")} </label>
                    <Select
                      className="border__grey mr-2"
                      placeholder="--"
                      optionFilterProp="children"
                      value={
                        selectedLocationTimingDD?.storeClosedSat === "Yes"
                          ? "Closed"
                          : selectedLocationTimingDD?.saturdayStart || ""
                      }
                      onChange={(e) => updateTimeDD(e, "saturdayStart")}
                    >
                      {morningDD.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                    {selectedLocationTimingDD?.storeClosedSat !== "Yes" && (
                      <Select
                        className="border__grey"
                        placeholder="--"
                        optionFilterProp="children"
                        value={selectedLocationTimingDD?.saturdayEnd || ""}
                        onChange={(e) => updateTimeDD(e, "saturdayEnd")}
                      >
                        {noonDD.map((item, index) => (
                          <Option key={index} value={item}>
                            {item}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </div>

                  <hr />
                </div>

                {/* <div className="col-md-12 p-0">
                  <div className="input__block">
                    <label> {t("Location QR Code")} </label>
                  </div>
                  <div className="input__block">
                    <div className="image_block border-0 p-0">
                    </div>
                    <p className="text-center linkText mt-2" onClick={() => handleQRCOdeGenerator()}>
                      {" "}
                      {t("QR Code Generator")}{" "}
                    </p>
                    <div className="qr-img-section">
                      <img src={qrCodeImg} alt="" />
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <Modal
              title={t("Delete")}
              className="modalconsupld__section"
              centered
              visible={delModalVisible}
              onCancel={handleDeleteCancel}
              width={400}
              footer={[
                <Button key="back" onClick={handleDeleteCancel}>
                  {t("Cancel")}
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  onClick={deleteLocationDataHandler}
                >
                  {t("Delete")}
                </Button>,
              ]}
            >
              <div className="col-lg-12">
                <div className="modal__body">
                  <div className="col-lg-12">
                    <div className="form__fields border-0 p-0">
                      <div className="row">
                        <div className="col-lg-12 text-center">
                          <p>
                            {t(
                              "Are you sure you want to delete this LOCATION ?"
                            )}{" "}
                          </p>
                          <h5>{t("THIS CAN NOT BE UNDONE")}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
          <div className="col-md-12">
            <Modal
              title={t("Upload Text")}
              className="modalconsupld__section"
              centered
              visible={QRModalVisible}
              onCancel={handleCloseQRCOdeGenerator}
              width={400}
              footer={[
                <Button key="back" onClick={handleCloseQRCOdeGenerator}>
                  {t("Cancel")}
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  onClick={updateQRCodeHandler}
                >
                  {t("Update")}
                </Button>,
              ]}
            >
              <div className="col-lg-12">
                <div className="modal__body">
                  <div className="col-lg-12">
                    <div className="form__fields border-0 p-0">
                      <div className="row">
                        <div className="col-lg-12 text-center">
                          <p>
                            <textarea
                              onChange={(e) => setQRCodeText(e.target.value)}
                            ></textarea>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CompanyLocation;
